import { render, staticRenderFns } from "./Ubtintroduction.vue?vue&type=template&id=68f2cf36&scoped=true&"
import script from "./Ubtintroduction.vue?vue&type=script&lang=js&"
export * from "./Ubtintroduction.vue?vue&type=script&lang=js&"
import style0 from "./Ubtintroduction.vue?vue&type=style&index=0&id=68f2cf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f2cf36",
  null
  
)

export default component.exports